import type { ReactNode } from 'react';
import type { IngestJobDTO } from '@contracts/ingest';
import { Button } from '../../../components/ui/button';
import { cn } from '../../../lib/utils';

const fmt = (n: number) => n.toLocaleString('vi-VN');
export const NOTHING_TO_APPROVE = 'Không có dòng nào duyệt được';

/** "Gồm K khoản tài chính: duyệt ở đây là xác nhận" (§8.5): money a batch writes is confirmed by this one click. */
export const financeLine = (k: number) => `Gồm ${fmt(k)} khoản tài chính: duyệt ở đây là xác nhận`;

/**
 * The ready card's foot (spec §8.1, mockup §1 `.bf`): "Duyệt N bản ghi" for the rows checked now, "Bỏ lô", and the
 * one line that matters before the click: the money it confirms, or that nothing can be approved (§13).
 */
export function BatchFooter({ job, busy, onApply, onDiscard, extra, className }: {
  job: IngestJobDTO; busy: boolean; onApply: () => void; onDiscard: () => void;
  /** The page's own words after the note (§8.2 "token đã dùng: X"). */
  extra?: ReactNode;
  className?: string;
}) {
  const n = job.counts.included;
  const k = job.counts.includedFinance;
  const note = n === 0 ? NOTHING_TO_APPROVE : k > 0 ? financeLine(k) : null;
  return (
    <div data-batch-footer="" className={cn('flex flex-wrap items-center gap-2 border-t border-[hsl(var(--h-border))] px-3 py-2.5', className)}>
      <Button size="sm" disabled={busy || n === 0} onClick={onApply}>{`Duyệt ${fmt(n)} bản ghi`}</Button>
      <Button size="sm" variant="outline" disabled={busy} onClick={onDiscard}>Bỏ lô</Button>
      {note !== null && (
        <p className={cn('min-w-[min(14rem,100%)] flex-1 text-xs text-[hsl(var(--h-muted-foreground))] lg:text-right',
          n === 0 && 'font-medium')}>{note}</p>
      )}
      {extra}
    </div>
  );
}
